import forEach from 'lodash-es/forEach';
import set from 'lodash-es/set';
import filter from 'lodash-es/filter';
import map from 'lodash-es/map';
import FormControl from '../form-control/form-control';

const ClassName = {
  BLOCK: 'order-selection',
  ITEM: 'order-selection__row',
  FORM_CONTROL: 'form-control',
  SELECT_LABEL: 'order-selection__select-label',
  INPUT_LABEL: 'order-selection__input-label',
  ADD_BUTTON: 'order-selection__button-add',
  DELETE_BUTTON: 'order-selection__button-delete',
  WRAPPER: 'order-selection__wrapper',
  INNER: 'order-selection__number-inner',
};

const Selectors = {
  SELECT: '[data-target="select"]',
  INPUT_NUMBER: '[data-target="input"]',
  PRICE: '[data-target="price"]',
  TOTAL_PRICE: '[data-target="total-price"]',
  VALIDATION: '[data-validation]',
};

class OrderSelection {
  constructor(elem) {
    this.block = elem;
    this.select = this.block.querySelector(Selectors.SELECT);
    this.selectLabel = this.block.getElementsByClassName(ClassName.SELECT_LABEL)[0];
    this.inputLabel = this.block.getElementsByClassName(ClassName.INPUT_LABEL)[0];
    this.input = this.block.querySelector(Selectors.INPUT_NUMBER);
    this.wrapper = this.block.getElementsByClassName(ClassName.WRAPPER)[0];
    this.addButton = this.block.getElementsByClassName(ClassName.ADD_BUTTON)[0];
    this.deleteButtons = this.block.getElementsByClassName(ClassName.DELETE_BUTTON);
    this.totalPrice = this.block.querySelector(Selectors.TOTAL_PRICE);
    this.selectedProducts = [];
    this.price = 0;


    this.init = this.init.bind(this);
    this.addNewSelect = this.addNewSelect.bind(this);
    this.deleteSelect = this.deleteSelect.bind(this);
    this.getSelectsCount = this.getSelectsCount.bind(this);
    this.deleteButtonSetAction = this.deleteButtonSetAction.bind(this);
    this.inputHandler = this.inputHandler.bind(this);

    this.init();
  }

  init() {
    this.addButton.addEventListener('click', this.addNewSelect);
    [...this.deleteButtons][0].addEventListener('click', this.deleteButtonSetAction);
    this.inputsHandler();
    this.updateSelect();
    this.buttonDeleteSelectHandler();
  }

  // Добавляем поле селект и инпут
  addNewSelect() {
    const newElement = this.createNewSelect();

    this.putNewElement(newElement);
    this.updateSelect();
    this.inputsHandler();
    this.updateNames();
    this.buttonDeleteSelectHandler();
  }

  // Обновляем все имена полей в зависимости от их количества
  updateNames() {
    const selects = this.getAllSelects();
    const inputs = this.getAllInputs();
    selects.forEach((select, index) => this.putNewNameToSelect(select, index));
    inputs.forEach((input, index) => this.putNewNameToInput(input, index));
  }

  // Меняем аттрибут name на новый
  putNewNameToInput(input, index) {
    const firstInputAttr = this.input.getAttribute('name');
    const newAttributeValue = firstInputAttr.replace('[0]', '[' + index + ']');
    input.setAttribute('name', newAttributeValue);
  }

  // Меняем аттрибут name на новый
  putNewNameToSelect(select, index) {
    const firstSelectAttr = this.select.getAttribute('name');
    const newAttributeValue = firstSelectAttr.replace('[0]', '[' + index + ']');
    select.setAttribute('name', newAttributeValue);
  }

  getSelectsCount() {
    return [...this.block.querySelectorAll(Selectors.SELECT)].length;
  }

  getAllSelects() {
    return this.block.querySelectorAll(Selectors.SELECT);
  }

  getAllInputs() {
    return this.block.querySelectorAll(Selectors.INPUT_NUMBER);
  }

  // Перебираем инпуты и вешаем слушатель
  inputsHandler() {
    const inputs = this.block.querySelectorAll(Selectors.INPUT_NUMBER);
    inputs.forEach((item) => this.setInputListener(item));
  }

  // Слушатель изменения вполе инпут
  setInputListener(item) {
    item.addEventListener('input', this.inputHandler);
  }

  inputHandler(event) {
    this.setInputMask(event.target);
    this.changePricePerCount(event.target);
    this.updateTotalPrice();
  }

  // Умножаем цену на выбранное число штук в инпуте
  changePricePerCount(elemFromRow) {
    const priceElem = elemFromRow.closest('.' + ClassName.ITEM).querySelector(Selectors.PRICE);
    const input = elemFromRow.closest('.' + ClassName.ITEM).querySelector(Selectors.INPUT_NUMBER);
    if (priceElem) priceElem.textContent = `${input.value * priceElem.dataset.price} ₽`;
  }

  // Проверяем если выбранное количество меньше допустимого
  setInputMask(input) {
    const wrapper = input.closest(`.${ClassName.INNER}`);
    const validationElem = wrapper.querySelector(Selectors.VALIDATION);
    if (input.value <= 0) {
        input.value = 1;
      }
    if (input.value >= Number(input.dataset.max)) {
        input.value = input.dataset.max;
        wrapper.classList.add('validation');
        validationElem.textContent = `${validationElem.dataset.validation} ${input.dataset.max} шт`;
        validationElem.classList.remove('d-none');
    } else {
      wrapper.classList.remove('validation');
      validationElem.classList.add('d-none');
      }
  }

  // Обновляем добавленное поле select
  updateSelect() {
    const selects = this.getAllSelects();
    const formControl = new FormControl(Array.from(selects)[selects.length - 1]);
    formControl.initSelect(this.selectedProducts).then((select) => {
      this.validationSelect(select);
    });
  }

  // Проверяем если в двух селектах будет совпадение
  validationSelect($select) {
    $select.on('select2:select', (e) => {
      let isAvailable = true;
      const selects = this.getAllSelects();
      this.selectedProducts.push(e.params.data.id);
      $select.attr('data-selected-id', e.params.data.id);
      Array.from(selects).forEach((select) => {
        if ($select.attr('data-selected-id') === select.getAttribute('data-selected-id')
        && (select.getAttribute('data-select2-id') !== $select.attr('data-select2-id'))) {
          $select.val('').trigger('change');
          isAvailable = false;
        }
      });
      const price = e.params.data.price;
      const stock = e.params.data.stock;
      if (isAvailable && price) {
        this.setPrice(price, e);
        this.setMaxQuantity(stock, e);
      }
      this.updateSelectedState();
    });
  }

  updateSelectedState() {
    this.selectedProducts = [];
    this.getAllSelects().forEach((item) => {
      this.selectedProducts.push(item.getAttribute('data-selected-id'));
    });
    document.dispatchEvent(new CustomEvent('iv.update.selected.list', {
      detail: this.selectedProducts,
    }));
  }

  // Устанавливаем цену для товара после выбора в селект поле
  setPrice(price, e) {
    const wrapper = e.target.closest(`.${ClassName.ITEM}`);
    const priceElem = wrapper.querySelector(Selectors.PRICE);
    if (priceElem) {
      priceElem.textContent = price + ' ₽';
      priceElem.dataset.price = price;
      this.changePricePerCount(priceElem);
    }
    this.updateTotalPrice();
  }

  setMaxQuantity(quantity, e) {
    const wrapper = e.target.closest(`.${ClassName.ITEM}`);
    const inputElem = wrapper.querySelector(Selectors.INPUT_NUMBER);
    inputElem.dataset.max = quantity;
    this.setInputMask(inputElem);
    this.changePricePerCount(inputElem);
    this.updateTotalPrice();
  }

  // Проходим по всем ценам товаров и обновляем итоговую цену
  updateTotalPrice() {
    const prices = this.block.querySelectorAll(Selectors.PRICE);
    let totalPrice = 0;
    prices.forEach((item) => totalPrice += Number(item.textContent.replace(/\D/g, '')));
    if (this.totalPrice) this.totalPrice.textContent = `Итого: ${totalPrice} ₽`;
  }

  // Слушатель по нажатию на кнопку удаления
  buttonDeleteSelectHandler() {
    Array.from(this.deleteButtons).forEach((item) => {
      item.addEventListener('click', this.deleteButtonSetAction);
    });
  }

  // Удаляем поле если оно не единственное, в противном случае очищаем значение
  deleteButtonSetAction(event) {
    if (this.getSelectsCount() !== 1) {
      this.deleteSelect(event);
      this.updateTotalPrice();
      this.updateSelectedState();
      return;
    }
    this.clearLastInputValue();
    this.clearLastSelectValue();
    this.clearPrice(event);
    this.updateTotalPrice();
    this.updateSelectedState();
  }

  // Очищаем значение поля с ценой товара
  clearPrice(event) {
    const priceElem = event.target.closest('.' + ClassName.ITEM).querySelector(Selectors.PRICE);
    if (priceElem) {
      priceElem.textContent = '0 ₽';
      priceElem.dataset.price = '0';
    }
  }

  // Очищаем значение поля input
  clearLastInputValue() {
    const lastInput = this.block.querySelector(Selectors.INPUT_NUMBER);
    lastInput.value = '1';
  }

  // Очищаем значение поля select
  clearLastSelectValue() {
    const lastSelect = this.block.querySelector(Selectors.SELECT);
    lastSelect.removeAttribute('data-selected-id');
    lastSelect.value = '';
    this.updateSelect();
  }

  // Вставляем новый элемент
  putNewElement(elem) {
    this.wrapper.insertAdjacentHTML('beforeend', elem);
  }

  // Создаем новый элемент wrapper с полями выбора товара и количества
  createNewSelect() {
    const price = this.totalPrice ? `<div class="order-selection__price" data-target="price" data-price="0">${this.price} ₽</div>`: '';
    return `
      <div class="${ClassName.ITEM}">
          <div class="order-selection__select">
              <label class="${this.selectLabel.classList}">${this.selectLabel.textContent}</label>
              <select class="${this.select.classList}" data-target="${this.select.getAttribute('data-target')}" placeholder="${this.select.getAttribute('placeholder')}" required="${this.select.getAttribute('required')}" url="${this.select.getAttribute('url')}"></select>
              <div class="invalid-feedback">Выберите хотя бы один товар из списка</div>
          </div>
          <div class="order-selection__number">
              <label class="${this.inputLabel.classList}">${this.inputLabel.textContent}</label>
              <div class="order-selection__number-inner">
                  <input class="${this.input.classList}" type="number" value="1" data-target="${this.input.getAttribute('data-target')}" data-max="100" />
                  ${price}
                  <div class="${ClassName.DELETE_BUTTON} btn btn-danger" data-action="delete">Удалить товар</div>
                  <div class="order-selection__max-quantity d-none" data-validation="В наличии только ">В наличии только </div>
              </div>
          </div>
       </div>
    `;
  }

  deleteSelect(event) {
    const targetToDelete = event.target.closest('.' + ClassName.ITEM);
    targetToDelete.remove();
    this.updateNames();
  }

  static getAllBlocks() {
    return Array.from(document.getElementsByClassName(ClassName.BLOCK));
  }

  static getAllInstances() {
    return map(filter(OrderSelection.getAllBlocks(), ({ins}) => ins), (item) => item.ins);
  }

  static initAllBlocks() {
    let Blocks = OrderSelection.getAllBlocks();
    forEach(Blocks, (block) => {
      if (block.ins) return;
      block.ins = new OrderSelection(block);
    });
  }
}

// Инициашизация;
OrderSelection.initAllBlocks();

// Экспорт;
set(window, ['Block', 'OrderSelection'], OrderSelection);
export default OrderSelection;
